import { useState, useRef } from "react";
import ResourceList from "../resources/ResourceList";
import { resourcesConfig } from "../resources/resourcesConfig";
import CrearUsuarioModal from "./CrearUsuarioModal";

const Usuarios = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    // Necesitamos un key para forzar la recarga del ResourceList
    const [refreshKey, setRefreshKey] = useState(0);

    const handleSuccess = () => {
        setRefreshKey(prev => prev + 1);
    };

    return (
        <>
            <ResourceList 
                key={refreshKey} 
                {...resourcesConfig.usuarios} 
                secondaryActionLabel="+ Crear Usuario"
                onSecondaryAction={() => setIsModalOpen(true)}
            />

            {isModalOpen && (
                <CrearUsuarioModal 
                    onClose={() => setIsModalOpen(false)} 
                    onSuccess={handleSuccess} 
                />
            )}
        </>
    );
};

export default Usuarios;